/* eslint-disable import/prefer-default-export */

import Environment from '../Domain/Models/Environment';
import OidConfig from '../Domain/Models/OidConfig';

interface DynamicRemoteEnvironment extends Environment
{
  /**
   * Cube server api base.
   */
  serverApiBase: string;

  /**
   * Leaderboard api base.
   */
  leaderboardApiBase: string;
}

const Local: DynamicRemoteEnvironment = {
  serverApiBase: 'https://host.docker.internal:5101',
  apiBase: 'https://host.docker.internal:5181',
  wsBase: 'wss://host.docker.internal:5181',
  jwtAuthorityBaseUrl: 'https://host.docker.internal:5161/connect/token',
  clientSecret: 'dev123',
  leaderboardApiBase: 'https://host.docker.internal:5111/api/v1',
};

const Manchester: DynamicRemoteEnvironment = {
  serverApiBase: '',
  apiBase: window.location.origin,
  wsBase: `wss://${document.location.host}`,
  jwtAuthorityBaseUrl: 'https://up-sso.urbanplaygroundtech.co.uk/connect/token',
  clientSecret: 'JDm7xLEGwFWQX3vomtIfBBoTNuJRhoBQ',
  leaderboardApiBase: 'https://host.docker.internal:5111/api/v1',
};

const Staging: DynamicRemoteEnvironment = {
  serverApiBase: 'https://thecube-staging.azurewebsites.net',
  apiBase: 'https://up-drc-staging.azurewebsites.net',
  wsBase: 'wss://up-drc-staging.azurewebsites.net',
  jwtAuthorityBaseUrl: 'https://up-sso-staging.azurewebsites.net/connect/token',
  clientSecret: 'B1wLMYKRXDCYBIascfa5Supu9nxLjAO4',
  leaderboardApiBase: 'https://thecube-leaderboard-staging.azurewebsites.net/api/v1',
};

const CanaryWharf: DynamicRemoteEnvironment = {
  serverApiBase: 'https://thecube-cw.urbanplaygroundtech.co.uk',
  apiBase: 'https://up-drc-cw.urbanplaygroundtech.co.uk',
  wsBase: 'wss://up-drc-cw.urbanplaygroundtech.co.uk',
  jwtAuthorityBaseUrl: 'https://up-sso.urbanplaygroundtech.co.uk/connect/token',
  clientSecret: 'JDm7xLEGwFWQX3vomtIfBBoTNuJRhoBQ',
  leaderboardApiBase: 'https://thecube-leaderboard.urbanplaygroundtech.co.uk/api/v1',
};

const Chicago: DynamicRemoteEnvironment = {
  serverApiBase: 'https://thecube-cgo.urbanplaygroundtech.com',
  apiBase: 'https://up-drc-cgo.urbanplaygroundtech.com',
  wsBase: 'wss://up-drc-cgo.urbanplaygroundtech.com',
  jwtAuthorityBaseUrl: 'https://up-sso-cgo.urbanplaygroundtech.com/connect/token',
  clientSecret: 'WxPle78jAMYV4HsZ9GnBDGIG',
  leaderboardApiBase: 'https://thecube-leaderboard.urbanplaygroundtech.co.uk/api/v1',
};

/**
 * Returns the environment configuration based on the config.
 * @returns The environment.
 */
export const getEnvironment = (): DynamicRemoteEnvironment =>
{
  switch (window.config.REACT_ENVIRONMENT)
  {
    case 'Manchester':
      return Manchester;
    case 'Staging':
      return Staging;
    case 'CanaryWharf':
      return CanaryWharf;
    case 'Chicago':
      return Chicago;
    case 'Local':
    default:
      return Local;
  }
};

/**
 * Gets the OID config.
 * @returns OID Config.
 */
export const getOidConfig = (): OidConfig =>
{
  const env = getEnvironment();

  return {
    authenticationUrl: env.jwtAuthorityBaseUrl,
    clientSecret: env.clientSecret,
    clientId: 'UrbanPlayground.DynamicRemoteApp',
    grantType: 'password',
    scope: 'TheCube.Server.Api UrbanPlayground.DynamicRemote.Api TheCube.LeaderboardServer.Api',
  };
};
